import React from "react";
import { Card, CardContent, Typography, Box, Button } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const LeadCard = ({ key, lead }) => {
  const navigate = useNavigate();

  const handleEditMode = (lead) => {
    console.log("Edit Mode On", lead);
    navigate("/sale/enquiries/editenquiry", {
      state: { customerId: lead.id, leadEdit: true },
    });
  };

  const handleFollowUp = () => {
    // Implement follow-up action here
    console.log("Follow Up clicked!");
  };

  return (
    <Card
      key={key}
      onClick={() => handleEditMode(lead)}
      sx={{
        mb: 2,
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        borderRadius: 1,
        transition: "transform 0.6s, border 0.6s ease-in-out",
        border: "1.33px solid transparent",
        borderImage: "linear-gradient(45deg, transparent, transparent) 1",
        "&:hover": {
          transform: "scale(1.02)",
          cursor: "pointer",
          border: "1.33px solid",
          borderImage: "linear-gradient(45deg, #f39c12, #5dade2, #8e44ad) 1",
        },
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            color: "grey",
          }}
        >
          {/* Left Column: Lead Details */}
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <PersonIcon sx={{ mr: 1, color: "#5dade2" }} />
              <Typography variant="body1">
                {lead.first_name} {lead.last_name}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
              <PhoneIcon sx={{ mr: 1, color: "#5dade2" }} />
              <Typography variant="body2">{lead.phone_number}</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
              <InventoryIcon sx={{ mr: 1, color: "#5dade2" }} />
              <Typography variant="body2">{lead.product}</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
              <LocationOnIcon sx={{ mr: 1, color: "#5dade2" }} />
              <Typography variant="body2">{lead.village}</Typography>
            </Box>
          </Box>

          {/* Right Column: Created At, Follow Up Button, Follow Up Date */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              justifyContent: "space-between",
              ml: 2,
              textAlign: "right",
            }}
          >
            <Typography variant="body2" sx={{ color: "gray" }}>
              Created at: {moment(lead.date).format("Do MMMM, YYYY")}
            </Typography>
            <Box>
              <Typography>
                {lead.next_followup_date &&
                moment(lead.next_followup_date, moment.ISO_8601, true).isValid()
                  ? moment(lead.next_followup_date).format("Do MMMM, YYYY")
                  : "Not Followed"}
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  backgroundColor: "lightgreen",
                  color: "white",
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                  borderRadius: "33px",
                  display: "inline-block",
                  paddingX: 1,
                }}
              >
                Follow Up
              </Typography>
            </Box>
          </Box>
        </Box>
        {lead.oldOwned === "Yes" && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            <span
              style={{
                fontWeight: "bold", // Makes the label bold
                color: "#333", // Sets the color of the label
                marginRight: "5px", // Space between label and value
              }}
            >
              Exchange:
            </span>
            <span
              style={{
                color: "#5DADE2", // Sets the color of the value
              }}
            >
              {lead.MakerName} - {lead.oldModalName} - {lead.manufactureYear} -{" "}
              {lead.conditionOfTractor}
            </span>
          </div>
        )}
        {moment(lead.next_followup_date, moment.ISO_8601, true).isValid() && (
          <Box>
            <div
              style={{
                padding: "10px", // Add padding to the container
                backgroundColor: "#f9f9f9", // Light background color
                border: "1px solid #ddd", // Add a border
                borderRadius: "8px", // For rounded corners
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  display: "flex", // Flexbox layout
                  flexDirection: "column", // Stack items vertically
                  alignItems: "flex-start", // Align items to the left
                }}
              >
                <p style={{ color: "#229954", margin: 0 }}>
                  {lead.last_discussion}
                </p>
                <p style={{ color: "#5DADE2", margin: "4px 0" }}>
                  {moment(lead.followup_date).format("LL")}
                </p>
                <p style={{ color: "grey", margin: 0 }}>
                  followup by: {lead.followupPersonfirstname}{" "}
                  {lead.followupPersonLastname}
                </p>
              </div>
            </div>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default LeadCard;
